import dayjs from "dayjs";
import { IGetAllTreinamentoFuncionarioInstrutorUseCase } from "../../../presentation/useCases/read/get_all_treinamento_funcionario_instrutor_use_case";
import { TreinamentoFuncionarioInstrutor } from "../../models/treinamento_funcionario_instrutor";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllTreinamentoFuncionarioInstrutorUseCase
 */

export class GetAllTreinamentoFuncionarioInstrutorUseCase implements IGetAllTreinamentoFuncionarioInstrutorUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getAllTreinamentoFuncionarioInstrutor(
    data: Date,
  ): Promise<TreinamentoFuncionarioInstrutor[]> {
    return this.repository.getAllTreinamentoFuncionarioInstrutor(dayjs(data).format('YYYYMMDD'));
  }
}
